import { gql } from "@apollo/client";

export const GET_MESSAGES = gql`
  query GetMessages($params: GetMessagesInput!) {
    messages(params: $params) {
      items {
        id
        conversationId
        requestUniqueKey
        contentHtml
        createdAt
        updatedAt
        sender {
          email
          firstName
          lastName
          fullName
          avatar
          isDeleted
        }
        attachments {
          id
          messageId
          fileName
          fileDisplayName
          filePath
          fileSize
          fileMimeType
        }
        isOwner
      }
      total
      page
      limit
      hasMore
    }
  }
`;
